import React from "react";
import {
  Dialog,
  DialogContent,
  IconButton,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";
import image from "../assets/img/image 134.png";

const StyledDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-paper": {
    borderRadius: theme.spacing(3),
    overflow: "hidden",
    // Remove the conflicting mobile breakpoint block — fullScreen handles it
  },
}));

const DashboardModal = ({ open, onClose }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <StyledDialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      fullScreen={isMobile}
    >
      <DialogContent
        sx={{
          padding: 0,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "#fff",
          position: "relative",
          overflow: "hidden",
          // Fill full height on mobile so flex centering works correctly
          ...(isMobile && { height: "100dvh" }),
        }}
      >
        <IconButton
          onClick={onClose}
          sx={{
            position: "absolute",
            top: 16,
            right: 16,
            zIndex: 10, // ← sit above the image on all screen sizes
            backgroundColor: "rgba(255, 255, 255, 0.92)",
            borderRadius: "50%",
            boxShadow: "0 2px 8px rgba(0,0,0,0.18)", // visible over any image tone
            "&:hover": {
              backgroundColor: "rgba(255, 255, 255, 0.8)",
            },
          }}
        >
          <CloseIcon />
        </IconButton>

        <img
          src={image}
          alt="Dashboard Modal"
          style={{
            width: isMobile ? "100%" : "auto",
            maxWidth: "100%",
            // 100dvh = dynamic viewport height → correct on iOS Safari with toolbar
            maxHeight: isMobile ? "100dvh" : "80vh",
            objectFit: "contain",
            display: "block", // removes phantom inline whitespace below image
            // No border-radius in fullscreen mode — looks odd edge-to-edge
            borderRadius: isMobile ? 0 : theme.spacing(3),
          }}
        />
      </DialogContent>
    </StyledDialog>
  );
};

export default DashboardModal;
